export default "__VITE_ASSET__CiZ4mnb5__"